import React from 'react';
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';

function reducePropsToState(propsList) {
  return propsList
    .map(({title}) => title)
    .filter(Boolean)
    .reverse()
    .join(' - ');
}

function handleStateChangeOnClient(title) {
  const nextTitle = title || '';
  if (nextTitle !== document.title) {
    document.title = nextTitle;
  }
}

class DocumentTitle extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
  };

  render() {
    if (this.props.children) {
      return React.Children.only(this.props.children);
    }
    return null;
  }
}

export default withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
)(DocumentTitle);



// WEBPACK FOOTER //
// ./spa/Components/DocumentTitle.jsx